"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _comparisonActions = require("./comparisonActions");
const initialState = {
  comparableProductsList: [],
  displayedProducts: [],
  specs: [],
  showDevices: true,
  showPlans: false,
  showBusinessSolution: false
};
const comparisonReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  switch (type) {
    case _comparisonActions.SET_COMPARABLE_PRODUCT_LIST:
      return {
        ...state,
        comparableProductsList: payload.productList
      };
    case _comparisonActions.SET_COMPARISON_SPECS:
      return {
        ...state,
        specs: payload.specs
      };
    case _comparisonActions.SET_DISPLAYED_PRODUCTS:
      return {
        ...state,
        displayedProducts: payload.products
      };
    case _comparisonActions.SET_SHOW_DEVICES:
      return {
        ...state,
        showDevices: payload.showDevices
      };
    case _comparisonActions.SET_SHOW_PLANS:
      return {
        ...state,
        showPlans: payload.showPlans
      };
    case _comparisonActions.SET_SHOW_BUSINESS_SOLUTIONS:
      return {
        ...state,
        showBusinessSolution: payload.showBusinessSolution
      };
    case _comparisonActions.UPDATE_DISPLAYED_PRODUCTS:
      return {
        ...state,
        displayedProducts: state.displayedProducts.map(productId => {
          if (productId === payload.previousId) {
            return payload.newId;
          }
          return productId;
        })
      };
    default:
      return state;
  }
};
var _default = comparisonReducer;
exports.default = _default;